import { render, staticRenderFns } from "./newSubcategory.vue?vue&type=template&id=46aebb67&scoped=true"
import script from "./newSubcategory.vue?vue&type=script&scoped=true&lang=js"
export * from "./newSubcategory.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./newSubcategory.vue?vue&type=style&index=0&id=46aebb67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aebb67",
  null
  
)

export default component.exports